module.exports = __webpack_public_path__ + "img/undraw_waiting.6b644bc2.svg";